<template>
  <div>

  </div>
</template>

<script>
export default {
  name: 'StorageProductStorageStockList'
}
</script>